var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Icon } from "../";
var MobileTooltip = /** @class */ (function (_super) {
    __extends(MobileTooltip, _super);
    function MobileTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleExpand = function (e) {
            _this.setState(function (prevState) { return ({ expand: !prevState.expand }); });
            e.stopPropagation();
        };
        _this.state = { expand: false };
        return _this;
    }
    MobileTooltip.prototype.renderMessage = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "rj-tooltip rj-mobile-tooltip" },
                React.createElement("div", { className: "rj-tooltip__message" }, this.props.message)),
            React.createElement("div", { className: "rj-tooltip__overlay", onClick: this.toggleExpand })));
    };
    MobileTooltip.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "rj-mobile-tooltip__icon", onClick: this.toggleExpand, "data-expanded": this.state.expand },
                React.createElement(Icon, { i: "i-16 i-o-info" })),
            this.state.expand && this.renderMessage()));
    };
    return MobileTooltip;
}(React.Component));
export { MobileTooltip };
//# sourceMappingURL=MobileTooltip.js.map